/**
 * Logotipo "kabeli" — SVG exportado del Figma (frame `logotipo_kabeli 1`,
 * node 9663:24240): letras navy con los puntos/acentos en verde de marca.
 */
export function KabeliLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="149"
      height="35"
      viewBox="0 0 149 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Kabeli"
    >
      <path d="M62.4529 29.5137H58.2222V33.7594H62.4529V29.5137Z" fill="#4FE02C" />
      <path d="M109.3 29.5137H105.069V33.7594H109.3V29.5137Z" fill="#4FE02C" />
      <path d="M123.635 9.50452H127.866V5.25879H123.635V9.50452Z" fill="#4FE02C" />
      <path
        d="M51.8757 12.5254C46.044 12.5254 41.2988 17.2872 41.2988 23.1397C41.2988 28.9921 46.044 33.7541 51.8757 33.7541H56.0662V29.5083H51.8757C48.374 29.5083 45.5296 26.6494 45.5296 23.1397C45.5296 19.63 48.3784 16.7711 51.8757 16.7711C55.373 16.7711 58.2218 19.63 58.2218 23.1397V27.3451H62.4526V23.1397C62.4526 17.2872 57.7075 12.5254 51.8757 12.5254Z"
        fill="#324459"
      />
      <path d="M127.864 11.6914H123.633V33.8804H127.864V11.6914Z" fill="#324459" />
      <path
        d="M38.4637 11.6916H34.2329C34.2329 15.2013 31.3841 18.0602 27.8868 18.0602H25.5076V1.14453H21.2769V33.8807H25.5076V22.3059H27.8868C31.3841 22.3059 34.2329 25.1648 34.2329 28.6745V33.8807H38.4637V28.6745C38.4637 25.2052 36.7956 22.1219 34.224 20.183C36.7956 18.2441 38.4637 15.1609 38.4637 11.6916Z"
        fill="#324459"
      />
      <path d="M118.083 1.14453H113.853V33.8807H118.083V1.14453Z" fill="#324459" />
      <path
        d="M75.8967 12.5264C73.5175 12.5264 71.3216 13.3208 69.5506 14.6536V1.14453H65.3198V23.1407C65.3198 28.9931 70.0649 33.755 75.8967 33.755C81.7286 33.755 86.4736 28.9931 86.4736 23.1407C86.4736 17.2881 81.7286 12.5264 75.8967 12.5264ZM75.8967 29.5138C72.3994 29.5138 69.5506 26.6548 69.5506 23.1452C69.5506 19.6355 72.3994 16.7765 75.8967 16.7765C79.3986 16.7765 82.2428 19.6355 82.2428 23.1452C82.2428 26.6548 79.394 29.5138 75.8967 29.5138Z"
        fill="#324459"
      />
      <path
        d="M98.7141 12.5254C92.8822 12.5254 88.1372 17.2872 88.1372 23.1397C88.1372 28.9339 92.7839 33.6553 98.5352 33.7495V33.7541H102.891V29.5083H98.7185C95.2213 29.5083 92.3723 26.6494 92.3723 23.1397C92.3723 19.63 95.2213 16.7711 98.7185 16.7711C101.478 16.7711 103.83 18.5439 104.702 21.0169H98.2131V25.2626H109.295V23.1397C109.291 17.2872 104.546 12.5254 98.7141 12.5254Z"
        fill="#324459"
      />
    </svg>
  );
}
